import { ApolloError } from '@apollo/client';
import { captureException } from '@/utils/sentry';
import { EmployeeNotifications } from '@/experiences/sales-portal/domain/accounts/screens/employee-list/types';
import { useGeneratedSalesPortalEmployeeNotificationsQuery } from '@/experiences/sales-portal/domain/accounts/screens/employee-list/blocs/documents/sales-portal-employee-notifications.generated';

interface UseEmployeeNotificationsLoaderParams {
  employeeUUID: string | undefined;
}

interface UseEmployeeNotificationsLoaderResult {
  error: ApolloError | undefined;
  notifications: EmployeeNotifications | null;
  refetch: () => Promise<unknown>;
}

export const useEmployeeNotificationsLoader = ({
  employeeUUID,
}: UseEmployeeNotificationsLoaderParams): UseEmployeeNotificationsLoaderResult => {
  const { data, error, refetch } =
    useGeneratedSalesPortalEmployeeNotificationsQuery({
      fetchPolicy: 'cache-and-network',
      onError: (apolloError) => {
        captureException(apolloError, {
          extra: {
            employeeUUID,
          },
        });
      },
      skip: !employeeUUID,
      // employeeUUID is technically guranteed here, this is to silence TS
      variables: { employeeUUID: employeeUUID ?? '' },
    });

  return {
    error,
    notifications: data?.employees_by_pk?.contact_info ?? null,
    refetch,
  };
};
